import { render } from "./NewsAdminEdit.vue?vue&type=template&id=4153bd04&ts=true"
import script from "./NewsAdminEdit.vue?vue&type=script&setup=true&lang=ts"
export * from "./NewsAdminEdit.vue?vue&type=script&setup=true&lang=ts"

import "./NewsAdminEdit.vue?vue&type=style&index=0&id=4153bd04&lang=css"

import exportComponent from "/codebuild/output/src3191932516/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/scan/admin/NewsAdminEdit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4153bd04"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4153bd04', __exports__)) {
    console.log('reload')
    api.reload('4153bd04', __exports__)
  }
  
  module.hot.accept("./NewsAdminEdit.vue?vue&type=template&id=4153bd04&ts=true", () => {
    console.log('re-render')
    api.rerender('4153bd04', render)
  })

}


export default __exports__